import React, { FunctionComponent } from 'react';
import pure from 'recompose/pure';
import { SegmentResponse } from '../models/itinerary';
import { Segment } from './Segment/Segment';

interface OwnProps {
  ids: Array<SegmentResponse['orderId']>;
}

interface SegmentsProps extends OwnProps {}

const SegmentsBase: FunctionComponent<SegmentsProps> = ({ ids }) => {
  return (
    <>
      {ids.map((segmentId, segmentIndex) => {
        return <Segment key={segmentIndex} segmentId={segmentId} />;
      })}
    </>
  );
};

/**
 * Stack of segments
 */
export const Segments = pure(SegmentsBase);

Segments.displayName = 'Segments';
